import RcTrigger, { TriggerProps as RcTriggerProps } from "rc-trigger";
import { AlignType } from "rc-trigger/lib/interface";
import React from "react";

type PlacementType =
  | "left"
  | "right"
  | "top"
  | "bottom"
  | "topLeft"
  | "topRight"
  | "bottomLeft"
  | "bottomRight"
  | "leftTop"
  | "leftBottom"
  | "rightTop"
  | "rightBottom";
interface TriggerProps extends Omit<RcTriggerProps, "popupAlign"> {
  placement?: PlacementType;
  offset?: number[];
}

const builtinPlacements: Record<PlacementType, { points: AlignType["points"] }> = {
  left: {
    points: ["cr", "cl"],
  },
  right: {
    points: ["cl", "cr"],
  },
  top: {
    points: ["bc", "tc"],
  },
  bottom: {
    points: ["tc", "bc"],
  },
  topLeft: {
    points: ["bl", "tl"],
  },
  topRight: {
    points: ["br", "tr"],
  },
  bottomRight: {
    points: ["tr", "br"],
  },
  bottomLeft: {
    points: ["tl", "bl"],
  },
  leftTop: {
    points: ["tr", "tl"],
  },
  leftBottom: {
    points: ["br", "bl"],
  },
  rightTop: {
    points: ["tl", "tr"],
  },
  rightBottom: {
    points: ["bl", "br"],
  },
};

const Trigger: React.FC<TriggerProps> = ({ placement = "top", offset, ...rcTriggerProps }) => {
  return (
    <RcTrigger
      {...rcTriggerProps}
      popupAlign={{ points: builtinPlacements[placement].points, offset }}
    />
  );
};
export default Trigger;
